import { render } from "./ProfileCardView.vue?vue&type=template&id=2553a59e&scoped=true"
import script from "./ProfileCardView.vue?vue&type=script&lang=js"
export * from "./ProfileCardView.vue?vue&type=script&lang=js"

import "./ProfileCardView.vue?vue&type=style&index=0&id=2553a59e&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2553a59e"]])

export default __exports__